import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import type { IBaseMenuItemProps, ILinkMenuItemProps } from "./types";

import { MenuItem } from "@/components/atoms/menuItem";
import { Typography } from "@/components/atoms/typography";
import { Icon } from "@/components/atoms/icons";
import { usePopoverContext } from "@/components/organisms/popover";

export function BaseMenuItem(props: IBaseMenuItemProps) {
  const { title, color, iconName, onClick } = props;

  const { t } = useTranslation("actions");
  const { setOpen } = usePopoverContext();

  function menuItemClickHandler() {
    setOpen(false);
    onClick?.();
  }

  return (
    <MenuItem onClick={menuItemClickHandler}>
      <div className={`flex-item-center gap-m1 color-${color}`}>
        {iconName && <Icon name={iconName} className={`color-${color}`} />}
        <Typography color={"inherit"} fontSize={"xs"}>
          {t(title)}
        </Typography>
      </div>
    </MenuItem>
  );
}

export function BaseLinkMenuItem(props: ILinkMenuItemProps) {
  const { to, ...rest } = props;

  return (
    <Link to={to}>
      <BaseMenuItem {...rest} />
    </Link>
  );
}
